<template>
  <div class="project-wrapper">
    <div class="project-container">
      <div class="project-content">
        <p class="project-current-step">{{ Translator('soprasolar.claim_request.step1.step') }}</p>
        <h1 class="project-title">{{ Translator('soprasolar.claim_request.step1.title') }}</h1>
        <save />
      </div>
      <div class="project-content">
        <form @submit="onSubmit" ref="form" id="formDemand" class="std-form">

          <div class="form-group">
            <div class="form-label-container">
              <label for="details" class="control-label required">
                {{ Translator('soprasolar.claim_request.step1.form.details') }}
              </label>
            </div>
            <textarea id="details" class="form-control" v-model="form.details" required></textarea>
          </div>

          <div class="form-group" style="margin-top: 40px;">
            <div class="form-label-container">
              <label class="control-label">{{ Translator('soprasolar.claim_request.step1.form.products_label') }}</label>
            </div>
            <form-product v-for="product, index in form.products" :key="index" v-bind:form="product" v-bind:index="index" v-bind:products="form.products" v-on:update="onUpdateProducts"></form-product>
            <button type="button" @click="onAddProduct()" class="button-add">
              <i class="ic ic-add"></i>
              {{ Translator('soprasolar.claim_request.step1.form.product.add_button') }}
            </button>
          </div>

          <div class="form-group">
            <div class="form-label-container">
              <label for="solutions" class="control-label required">
                {{ Translator('soprasolar.claim_request.step1.form.solutions') }}
              </label>
            </div>
            <textarea id="solutions" class="form-control" v-model="form.solutions" required></textarea>
          </div>

          <div class="form-group">
            <div class="form-label-container">
              <label class="control-label">
                <span>{{ Translator('soprasolar.claim_request.step1.form.files') }}<br></span>
              </label>
            </div>

            <div v-for="(file, index) in form.files" :key="index" >
              <file-upload v-model="form.files[index]" @update="onUpdateLoopFile($event, index)" />
            </div>
            <button type="button" @click="onAddFile" class="button-add" v-if="isAllFilesCompleted">
              <i class="ic ic-add"></i>
              {{ Translator('soprasolar.claim_request.step1.form.add_file') }}
            </button>
          </div>

        </form>
      </div>
    </div>
    <div class="project-footer">
      <div class="project-actions">
        <button type="submit" class="button-flat" form="formDemand" :disabled="isLoading">
          {{ Translator('soprasolar.claim_request.next') }}
          <i class="ic ic-arrow-right" v-if="!isLoading"></i>
          <span class="button-loader" v-if="isLoading"></span>
        </button>
        <button type="button" class="button-link" @click="onPrevious">
          <i class="ic ic-arrow-left"></i>
          {{ Translator('soprasolar.project.previous') }}
        </button>
      </div>
    </div>
    <p class="project-legend">* {{ Translator('soprasolar.claim_request.required_field') }}</p>
  </div>
</template>
<style scoped lang="scss">
  @import "~@/soprasolar-claim/assets/styles/import";
  .actions {
    text-align: center;
  }
  .button-add {
    @include resetBtn;
    display: inline-block;
    color: $color-main;
    margin-left: rem(15);
    padding-top: rem(10);
    padding-bottom: rem(10);
    font-size: rem(14);
    .ic {
      vertical-align: middle;
      margin-right: rem(5);
      font-size: rem(22);
    }
  }
</style>
<script>
import Save from '@/soprasolar-claim/components/Save';
import FormControl from 'aw-front-helpers/classes/formControl';
import FormProduct from '@/soprasolar-claim/components/Form-product';
import AppControlService from '@/soprasolar-claim/services/AppControl';
import FileUpload from '@/soprasolar-claim/components/File-upload';


export default {
  name: 'step-1',
  components: {
    Save,
    FormProduct,
    FileUpload
  },

  data () {
    return {
      datas: AppControlService.datas,
      isLoading: false,
      form: {},
      isAllFilesCompleted: true
    }
  },

  created() {
    AppControlService.on('datas', this._onUpdateDatas);
  },

  beforeDestroy() {
    AppControlService.off('datas', this._onUpdateDatas);
  },

  mounted() {
    this._form = new FormControl(this.$refs.form);
    if(this.datas.step1) this.form = this.datas.step1;
    else {
      this.form.products = [];
      this.form.files = [];
    }
  },

  methods: {
    onSubmit(pEvt) {
      pEvt.preventDefault();
      if(this._form.isValidate) {
        if(this.isLoading) return;
        this.isLoading = true;
        for( let i = this.form.files.length - 1; i >= 0; i-- ) {
          if(!this.form.files[i]) this.form.files.splice(i, 1);
        }
        AppControlService.update('step1', this.form).then( () => {
          AppControlService.goToNextStep();
        }).catch(console.error).then(() => {
          this.isLoading = false;
        })
      }
    },

    onUpdateProducts() {
      this.$forceUpdate();
    },

    onAddProduct() {
      this.form.products.push({});
      this.$forceUpdate();
    },

    onAddFile() {
      this.form.files.push(null);
      this.checkAllFiles();
      this.$forceUpdate();
    },

    onUpdateLoopFile(datas, index) {
      if(!datas) this.form.files.splice(index, 1);
      this.checkAllFiles();
      this.$forceUpdate();
    },

    onPrevious() {
      AppControlService.goToPrevStep();
    },

    Translator(key, datas = null) {
      return window.Translator.trans(key, datas);
    },

    checkAllFiles() {
      this.isAllFilesCompleted = true;
      this.form.files.forEach(file => {
        if(!file) this.isAllFilesCompleted = false;
      });
    },

    _onUpdateDatas(datas) {
      this.datas = datas;
      if(this.datas.step1) this.form = this.datas.step1;
    }
  }
};
</script>